import React from "react";
import {Route, Routes} from "react-router-dom";
import {
  Area,
  Bar,
  Calendar, ColorMapping,
  ColorPicker,
  Customers,
  Editor,
  Feedback,
  Financial,
  Home,
  Kanban,
  Line,
  Orders,
  Pie,
  Pyramid,
  Stacked,
  Payments,
} from "../pages";
import {FiShoppingBag} from "react-icons/fi";
import {
  AiOutlineCalendar,
  AiOutlineShoppingCart,
} from "react-icons/ai";
import {IoMdContacts} from "react-icons/io";
import {RiContactsLine} from "react-icons/ri";

export const sideMenuRoutes = [
  {
    title: 'Painel',
    links: [
      {
        name: 'inicio',
        icon: React.createElement(FiShoppingBag as any),
      },
    ],
  },
  {
    title: 'Planejamento',
    links: [
      {
        name: 'pedidos',
        icon: React.createElement(AiOutlineShoppingCart as any),
      },
      {
        name: 'calendario',
        icon: React.createElement(AiOutlineCalendar as any),
      },
    ],
  },

  {
    title: 'Pessoas',
    links: [
      {
        name: 'avaliacoes',
        icon: React.createElement(IoMdContacts as any),
      },
      {
        name: 'clientes',
        icon: React.createElement(RiContactsLine as any),
      },
    ],
  },
];

export const MainRoot = () => {
  return (
    <Routes>
      <Route path="/" element={(<Home />)}/>
      {/*<Route path="/privacy" element={(<Privacy />)}/>*/}
      <Route path="/pay" element={(<Payments />)}/>

      {/* dashboard  */}
      <Route path="/inicio" element={(<Home/>)}/>

      {/* pages  */}
      <Route path="/pedidos" element={<Orders/>}/>
      <Route path="/avaliacoes" element={<Feedback/>}/>
      <Route path="/clientes" element={<Customers/>}/>

      {/* apps  */}
      <Route path="/kanban" element={<Kanban/>}/>
      <Route path="/editor" element={<Editor/>}/>
      <Route path="/calendario" element={<Calendar/>}/>
      <Route path="/color-picker" element={<ColorPicker/>}/>

      {/* charts  */}
      <Route path="/line" element={<Line/>}/>
      <Route path="/area" element={<Area/>}/>
      <Route path="/bar" element={<Bar/>}/>
      <Route path="/pie" element={<Pie/>}/>
      <Route path="/financial" element={<Financial/>}/>
      <Route path="/color-mapping" element={<ColorMapping/>}/>
      <Route path="/pyramid" element={<Pyramid/>}/>
      <Route path="/stacked" element={<Stacked/>}/>
    </Routes>
  )
}
